if ( !window.requestAnimationFrame ) {
  window.requestAnimationFrame = ( function() {
    return window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(callback, element) {

        window.setTimeout( callback, 1000 / 60 );

      };
  })();
}

function getCSS(property, el) {
  return parseInt(window.getComputedStyle(el, null)[property], 10);
}

function scrollToY(scrollTargetY, speed, easing) {
  var scrollY = window.scrollY || document.documentElement.scrollTop,
    scrollTargetY = scrollTargetY || 0,
    speed = speed || 2000,
    easing = easing || 'easeOutSine',
    currentTime = 0;

  var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

  var easingEquations = {
    easeOutSine: function (pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function (pos) {
      return (-0.5 * (Math.cos(Math.PI * pos) - 1));
    },
    easeInOutQuint: function (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow((pos - 2), 5) + 2);
    }
  };

  function tick() {
    currentTime += 1 / 60;

    var p = currentTime / time;
    var t = easingEquations[easing](p);

    if (p < 1) {
      requestAnimationFrame(tick);

      window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }

  tick();
}

window.addEventListener('load', function() {
  Product();
  if (typeof window.setupInitialCarousels === 'function') {
    setupInitialCarousels();
  }
  if (typeof window.setupLightbox === 'function') {
    setupLightbox();
  }
})

function isTouch() {
  return 'ontouchstart' in window
    ||  navigator.maxTouchPoints;
}

function softLoad(st, objs) {
  objs.each(function(){
    var fadePoint = st + ($(window).height() / 4*3);
    if (fadePoint > $(this).offset().top) {
      $(this).css({
        opacity: 1,
        transform: 'translateY(0) translateZ(0)'
      });
    }
  });
}

var begin = 0;
function startCounter() {
  var st = ($(document).scrollTop() + $(window).height()) - 150,
    obj = $('.counter').offset().top;
  if (st > obj) {
    begin = 1;
    $(window).off('scroll', startCounter);
    $('.counter span').each(function () {
      $(this).prop('Counter', 0).animate({
        Counter: $(this).text()
      }, {
        duration: 4000,
        easing: 'linear',
        step: function (now) {
          $(this).text(Math.ceil(now));
        }
      });
    });
  }
}

function blogFooter() {
  $.ajax({
    url: "/php/include/blogFoot.php",
    data: null,
    type: 'POST',
    success: function(response) {
      $('footer .footBlogs').empty().append('<h5>Latest Blogs</h5>' + response);
    },
    error: function() {
      console.error("Ajax Error");
    }
  });
}

function garageBlogFooter() {
  $.ajax({
    url: "/php/include/blogFootGarage.php",
    data: null,
    type: 'POST',
    success: function(response) {
      $('footer .footBlogsGarage').empty().append('<h5>Latest Blogs</h5>' + response);
    },
    error: function() {
      console.error("Ajax Error");
    }
  });
}


$(document).ready(function() {
  console.log("Is touch? " + isTouch());
  // Static variables
  var body = $('body'),
    header = $('header'),
    headerOffset = 48,
    nav = $('nav'),
    navOffset = nav.offset().top,
    content = $('article').find('.content');



  // =========================================================================  Scroll Events === //

  var scrolled = false;
  window.onscroll = scrollHandler();
  function scrollHandler() {
    scrolled = true;
  }

  function scrollEvents() {
    if (scrolled) {
      var st = $(document).scrollTop();
      var wh = $(window).height();
      softLoad(st, content);
      if (st > navOffset && $(document).width() > 768) {
        nav.addClass('fix');
        body.addClass('fix');
      } else {
        nav.removeClass('fix');
        body.removeClass('fix');
      }
      if ($('.counter').length && !begin) {
        startCounter();
      }
      if ($(document).width() == 768) {
        if (st > headerOffset) {
          header.addClass('fix');
          body.addClass('fix');
        } else {
          header.removeClass('fix');
          body.removeClass('fix');
        }
      }
    }
    requestAnimationFrame(scrollEvents);
  }

  scrollEvents();

  // ========================================================================= End Scroll Events === //

  body.css({
    opacity: 0,
    transition: 'opacity 0.23s ease-out'
  });

  if ($(document).width() > 1199) {
    content.each(function () {
      $(this).css({
        opacity: 0,
        transform: 'translateY(50px)',
        transition: 'opacity 0.35s ease-out, transform 0.35s ease-out'
      });
    });
  }

  $(window).load(function () {
    body.css({
      opacity: 1
    });
  });

  // =========================================================================== End animation events

  function createMobileMenu() {
    if ($(document).width() <= 768 && !header.find('.mobile-menu').length)
      $('header .content').append('<div class="mobile-menu"><span></span></div>');
    else {
      if (header.find('.mobile-menu').length) {
        $('mobile-menu').remove();
      }
    }
  }

  createMobileMenu();
  $(window).on('resize', function () {
    createMobileMenu();
  });

  var mbs = 0;
  $(document).on('touchend click', '.mobile-menu', function (e) {
    if (e.type == 'touchend') e.preventDefault();
    if (!mbs) {
      body.append('<div class="mbs"></div>');
      mbs = 1;
    }
    $('nav').addClass('o');
    $('.mbs').css({
      opacity: 1,
      "z-index": 9999
    });
  });
  $(document).on('touchend click', '.mbs', function () {
    $('.mbs').css({
      opacity: 0,
      "z-index": -20
    });
    $('nav').removeClass('o');
  });

  nav.find('li[class*="drop"] > a').click(function (e) {
    if (isTouch() && !$(this).data('clicked')) {
      e.preventDefault();
      $(this).data({
        clicked: true
      });
      nav.find('li[class*="-drop"] > a').not(this).data({
        clicked: false
      });
    }
  });

  nav.find('li.drop').on('mouseleave', function () {
    if (isTouch())
      $(this).find(' > a').data({
        clicked: false
      });
  });

  // ====================================================================== End Touch Events ===== //

  $(document).on('click', '.archive > span', function () {
    $('.archive > ul').stop().toggle();
  });

  $(document).on('click', '.archive > ul > li > span', function () {
    $('.archive > ul > li > ul').not($(this).next('ul')).stop().slideUp(300);
    $(this).next('ul').stop().slideToggle(300);
  });

  $(document).on('click', '.archive > ul > li > ul > li > a', function (e) {
    e.preventDefault();
    var month = $(this).data('month'),
      blog = $('#blog'),
      blogContent = blog.find('.content');
    $.ajax({
      url: '/news/include/archive.php',
      data: {
        month: month
      },
      type: 'POST',
      beforeSend: function () {
      },
      success: function (response) {
        $('.archive > ul, .archive > ul > li > ul').stop().slideUp(300);
        blogContent.empty().append(response);
      },
      error: function () {
        console.error("Ajax Error");
      }
    })
  });

  $(document).on('click', '.loadMore a', function (e) {
    e.preventDefault();
    var page = $(this).data('page');
    if ($('.noMore').length) {
      $(this).remove();
      return;
    }

    fetch('/php/routes/blogJsActions.php', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify({
        action: 'LOAD_MORE',
        page: page
      }),
    })
      .then(response => response.text())
      .then(html => {
        $('.loadMore').before(html.toString());
        $('.loadMore a').data({
          page: page + 1
        });
      })
  });

  var rbs = 0;
  $(document).on('click', '#call-out, #r-call-out', function (e) {
    e.preventDefault();
    $.ajax({
      url: '/php/include/repair-form.html',
      beforeSend: function () {
      },
      success: function (response) {
        if (!rbs) {
          body.append('<div class="rbs"></div>' + response);
          rbs = 1;
        }
        $('#popUp').delay(20).css({
          opacity: 1,
          "z-index": 200000
        });
        $('.rbs').delay(20).css({
          opacity: 1,
          "z-index": 190000
        });
      },
      error: function () {
        console.error("Ajax error. Please check your internet connection.");
        $('.rbs').delay(100).css({
          opacity: 0,
          "z-index": -50
        });
      }
    });
  });

  $(document).on('touchend, click', '.rbs, #popUp .close', function () {
    $('.rbs, #popUp').css({
      opacity: 0,
      "z-index": -50
    });
  });

  /* ======================================================================== */

  $(document).on('click', '.links > a:first-child', function (e) {
    if (e.target.id !== 'no') {
      e.preventDefault();
      var areasPopup = $('<div id="areas_overlay">' +
        '<div class="box">' +
        '<button type="button" id="areas_close"></button>' +
        '<h4>Area we cover <small>From Lincolnshire to Kent, we work with' +
        ' clients across the East of England</small></h4>' +
        '<p>We cover all of East Anglia for new installations, repairs and ' +
        'servicing. The counties our services cover include Norfolk, Suffolk, ' +
        'Cambridgeshire, Lincolnshire, London, Essex, Hertfordshire, Kent, ' +
        'Bedfordshire, Rutland and Northamptonshire.</p>' +
        '<a href="/contact-us" title="Book a Survey Now">' +
        '<b>Book a Survey Now</b>' +
        'Please call us on 01603 410304 or 0800 0180304 to arrange a free site survey and quotation.</a>' +
        '</div></div>');

      $('body').append(areasPopup);

      $('html, body').css({
        overflow: 'hidden'
      });

      document.addEventListener('click', function areaRemove(e) {
        var areasOverlay = document.getElementById('areas_overlay');
        if (e.target == areasOverlay ||
          e.target == areasOverlay.getElementsByTagName('button')[0]) {
          e.preventDefault();
          document.body.removeChild(areasOverlay);
          document.removeEventListener('click', areaRemove);
          document.body.style.overflow = 'auto';
          document.documentElement.style.overflow = 'auto';
        }
      });
    }
  });

  var sending = 0;
  $(document).on('submit', '#contact', function (e) {
    e.preventDefault();
    if(sending === 1) return;
    var data = $(this).serialize(),
      that = $(this);
    sending = 1;
    $.ajax({
      url: '/php/routes/contact.php',
      type: 'POST',
      data: data,
      beforeSend: function () {
        that.find('button').text('Sending...');
        that.find('.error').length &&
        that.find('.error').remove();
      },
      success: function (response) {
        if (response === 'success') {
          that.empty().html('<p id="tagContactID">Thank you for your interest. We will get back' +
            ' to you as soon as possible.</p>');
          sending = 0;
        } else {
          that.find('button').text('Send Enquiry')
            .before('<p class="error">' + response + '</p>');
          sending = 0;
        }
      },
      error: function () {
        that.find('button').text('Send Enquiry')
          .before('<p class="error">Something went wrong. Please try again.</p>');
      }
    });
  });

  var select = document.getElementsByClassName('select')[0];

  select &&
  select.addEventListener('click', function (e) {
    var list = select.getElementsByTagName('li'),
      span = select.getElementsByTagName('span')[0];

    if (e.target == span) {
      select.classList.add('open');
    }
    for (var i = 0; i < list.length; i++) {
      if (e.target == list[i]) {
        select.firstElementChild.value = list[i].innerText;
        span.innerText = list[i].innerText;
      }
    }
  });

  select &&
  document.addEventListener('click', function (e) {
    if (e.target !== select.children[1]) {
      select.classList.remove('open');
    }
  });

  $(document).on('submit', '#repair-call-out', function(e) {
    e.preventDefault();
    var that = $(this);
    var data = that.serialize();
    $.ajax({
      url: '/php/routes/repairForm.php',
      type: 'POST',
      data: data,
      beforeSend: function () {
        that.find('button').text('Sending...');
        that.find('.error').length &&
        that.find('.error').remove();
      },
      success: function (response) {
        if (response == 'success') {
          that.empty().html('<p id="tagContactID-CO">Thank you for your interest. We will get back' +
            ' to you as soon as possible.</p>');
        } else {
          that.find('button').text('Send Enquiry')
            .before('<p class="error">' + response + '</p>');
        }
      },
      error: function () {
        that.find('button').text('Send Enquiry')
          .before('<p class="error">Something went wrong. Please try again.</p>');
      }
    })
  });


  var cbWidth = document.body.clientWidth;
  var mobileSize = 767;
  var mobile = 0;
  var nav_ul = document.querySelector('nav > ul');
  var nav_contact = document.createElement('li');
  var callNow = document.createElement('a');

  nav_contact.className = 'navContact';
  nav_contact.innerHTML = '<div class="contact"><a href="tel:0800-0180304" onclick="return gtag_report_conversion2(\'tel:0800-0180304\');" title="Telephone Number">Call Now</a><a href="mailto:sales@cooksdoors.co.uk" title="Email Address" onclick="return gtag_report_conversion(\'mailto:sales@cooksdoors.co.uk\');">Email Us</a></div>';

  callNow.title = 'Call Now!';
  callNow.innerText = 'Tap to Call Now!';
  callNow.className = 'mob_call_now';
  callNow.href = 'tel:0800-0180304';


  function responsiveHandler() {
    if (cbWidth <= mobileSize) {
      mobile = 1;

      document.body.appendChild(callNow);
      nav_ul.append(nav_contact);
    } else {
      if (mobile) {
        nav_ul.removeChild(nav_contact);
        document.body.removeChild(callNow);
      }
    }
  }

  responsiveHandler();

  window.addEventListener('resize', function() {
    responsiveHandler();
  })
});
